import {RGBA} from '../../types/color.types';

function hexToRGBA(hex: string): RGBA {
  let fullHex = hex;

  if (hex.length === 4) {
    // Expand short hex value to full hex value
    fullHex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
  }

  let alpha = 1;

  if (fullHex.length === 9) {
    // Extract alpha value from hex
    alpha = parseFloat((parseInt(fullHex.substring(7, 9), 16) / 255).toFixed(3));
    fullHex = fullHex.substring(0, 7);
  }

  const [r, g, b] = fullHex
    .substring(1)
    .match(/.{1,2}/g)
    .map((n) => parseInt(n, 16));

  return {r, g, b, a: alpha};
}

export default hexToRGBA;
